import { render, staticRenderFns } from "./dispatcherpunchin.vue?vue&type=template&id=395790c6&scoped=true"
import script from "./dispatcherpunchin.vue?vue&type=script&lang=js"
export * from "./dispatcherpunchin.vue?vue&type=script&lang=js"
import style0 from "./dispatcherpunchin.vue?vue&type=style&index=0&id=395790c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395790c6",
  null
  
)

export default component.exports